// extracted by mini-css-extract-plugin
export default {"fieldsGrid":"PassReceipt_fieldsGrid__e9o7f"};